import DialogContentText from './DialogContentText';
export * from './DialogContentText';
export default DialogContentText;